import { render, staticRenderFns } from "./CompanyContactEdit.vue?vue&type=template&id=9b84eba4&scoped=true&"
import script from "./CompanyContactEdit.vue?vue&type=script&lang=ts&"
export * from "./CompanyContactEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b84eba4",
  null
  
)

export default component.exports